<template>
  <v-flex>
    <v-tabs v-model="active" color="#00695c" dark slider-color="blue">
      <v-tab-item v-for="n in 2" :key="n">
        <v-card flat>
          <grafico-coluna/>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-flex>
</template>
<script>
import CustoTotalCustoOperacionalPrecoRecebido from "../graficos/CustoTotalCustoOperacionalPrecoRecebido.vue";

export default {
  components: {
    "grafico-coluna": CustoTotalCustoOperacionalPrecoRecebido,
  },
  data: () => ({
    active: null
  })
};
</script>
<style scoped>
.texto {
  font-size: 10px;
}
.flex {
  background-color: #00695c;
}
</style>
